module.exports = __webpack_public_path__ + "rosacea_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_7_after.jpg
// module id = 989
// module chunks = 0